import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
  select,
} from '@ngrx/store';
import { pipe } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { AllActionsUnion } from '../../../app.actions';
import { Reservation } from '../../../models/reservation/reservation';
import {
  resetState,
  storeErrorMessage,
  storeReservation,
  updateLoading,
} from './reservation.actions';

export interface ReservationState {
  isLoading: boolean;
  errorMessage: string;
  reservation: Reservation | null;
}

const initialState: ReservationState = {
  isLoading: false,
  errorMessage: '',
  reservation: null,
};

export const featureName = 'reservationFeature';

export function reservationReducer(
  state_: ReservationState | undefined,
  action: AllActionsUnion,
): ReservationState {
  const reducer_ = createReducer<ReservationState>(
    initialState,
    on(
      updateLoading,
      (state, { payload }): ReservationState => {
        return { ...state, isLoading: payload };
      },
    ),
    on(
      storeErrorMessage,
      (state, { payload }): ReservationState => {
        return { ...state, errorMessage: payload };
      },
    ),
    on(
      storeReservation,
      (state, { payload }): ReservationState => {
        return { ...state, reservation: payload };
      },
    ),
    on(
      resetState,
      (): ReservationState => {
        return { ...initialState };
      },
    ),
  );
  return reducer_(state_, action);
}

const getFeature = createFeatureSelector<ReservationState>(featureName);

export const getIsLoading = pipe(
  select(
    createSelector(
      getFeature,
      v => v.isLoading,
    ),
  ),
  distinctUntilChanged(),
);

export const getErrorMessage = pipe(
  select(
    createSelector(
      getFeature,
      v => v.errorMessage,
    ),
  ),
  filter(message => message !== ''),
  distinctUntilChanged(),
);

export const getReservation = pipe(
  select(
    createSelector(
      getFeature,
      v => v.reservation,
    ),
  ),
  distinctUntilChanged(),
);
